import React, { Fragment } from "react";
import DataTable from "react-data-table-component";
import { sentenceCase } from "../../../utils/case";
import { useTranslation } from "react-i18next";

const DataTableComponent = ({
  data,
  columns,
  meta,
  onPageChange,
  onPerPageChange,
  onSort,
  sortServer = true,
  defaultSortFieldId,
  defaultSortAsc = true,
  center
}) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <DataTable
        data={data}
        columns={columns}
        striped
        center={center}
        pagination
        paginationServer
        sortServer={sortServer}
        defaultSortFieldId={defaultSortFieldId}
        defaultSortAsc={defaultSortAsc}
        paginationTotalRows={meta?.total || 0}
        paginationDefaultPage={meta?.page || 1}
        onChangePage={onPageChange}
        onChangeRowsPerPage={onPerPageChange}
        onSort={onSort}
        noDataComponent={sentenceCase(t("no data"))}
        paginationRowsPerPageOptions={[10, 30, 50, 100]}
      />
    </Fragment>
  );
};

export default DataTableComponent;